<template>
    <div class="homeContainerRefuge">
        <br><br>

        <div class="container">
            <h3 class="font-weight-bold mb-4 centers" id="top">Bénévole</h3>
            <div class="mid">
            </div>
        </div>


        <div class="row">
            <div class="col-lg-12" v-for="benevole in  benevoles " v-bind:key="benevole.id">
                <div class="">
                    <div class="container " style="margin-top: 20px;">
                        <h4 class="titleblue titlecontainershop"><b>{{ benevole.titre }}</b></h4>
                        <br>
                        <p v-html="benevole.content" class="contentclassService"></p>
                        <div class="row">
                            <div class="col-lg-4" v-if="benevole.image">
                                <img :src="'https://admin.asso-refuge.fr/images/' + benevole.image"
                                    alt="illustration d'un bénévole de l'association"
                                    style="display: block; margin-left: auto; margin-right: auto; width: 100%;" />
                            </div>

                            <div class="col-lg-4" v-if="benevole.image2">
                                <img :src="'https://admin.asso-refuge.fr/images/' + benevole.image2"
                                    alt="illustration d'un bénévole de l'association"
                                    style="display: block; margin-left: auto; margin-right: auto; width: 100%;" />
                            </div>

                            <div class="col-lg-4" v-if="benevole.image3">
                                <img :src="'https://admin.asso-refuge.fr/images/' + benevole.image3"
                                    alt="illustration d'un bénévole de l'association"
                                    style="display: block; margin-left: auto; margin-right: auto; width: 100%;" />
                            </div>

                        </div>
                    </div>

                </div>


            </div>
        </div>
    </div>

</template>

<style src="../assets/css/besoins.css"></style>
<script>
export default {
    data() {
        return {
            benevoles: [],
        };
    },
    mounted() {
        const idSite = this.$idSite;
        fetch(`https://admin.asso-refuge.fr/getBenevoles/${idSite}`)
            .then(response => response.json())
            .then(data => {
                const formattedServices = data.map(benevole => ({
                    ...benevole,
                    content: benevole.content.replace(/\r\n/g, '<br>'),
                }));
                this.benevoles = formattedServices;
            })
            .catch(error => {
                console.error('Il y a eu un problème avec votre requête :', error.message);
            });
    }
};

</script>
